exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel {\n  height: 700px;\n}\n@media screen and (max-width: 800px) {\n.carousel {\n    height: 500px;\n}\n}\n@media screen and (max-width: 480px) {\n.carousel {\n    height: 300px;\n}\n}\n.carousel__left .btn, .carousel__right .btn {\n  background-color: rgba(30, 30, 30, 0.5);\n}\n.carousel__left .btn:hover, .carousel__right .btn:hover {\n  background-color: rgba(30, 30, 30, 0.7);\n}", ""]);

// exports
